import { useLocation } from 'react-router-dom';

interface SearchParams {
  [key: string]: any;
}

export default function useQuery(param?: string) {
  return new URLSearchParams(useLocation().search).get(param);
}
